import { PropType } from '@vue/composition-api';
import { HighlightsButtonComponent } from '@front-app/modules/group/highlights/model';
import { GroupWithCommunity } from '@front-app/services/GroupsApi/GroupModel';

export const BUTTON_EDITOR_PROPS = {
	group: {
		type: Object as PropType<GroupWithCommunity>,
		required: true,
	},
	value: {
		type: Object as PropType<HighlightsButtonComponent>,
		required: true,
	},
} as const;
